import { RegistrationPeriod } from '@/@types/generated/models/RegistrationPeriod'
import { register } from './enum'

export const RegistrationPeriodLabels: Record<RegistrationPeriod, string> = {
  [RegistrationPeriod.ONE_YEAR]: 'One Year',
  [RegistrationPeriod.TWO_YEARS]: 'Two Years',
  [RegistrationPeriod.SEVEN_DAYS]: '7 Days',
  [RegistrationPeriod.NINETY_DAYS]: '90 Days',
}

export const RegistrationPeriodDescriptions: Record<
  RegistrationPeriod,
  string
> = {
  [RegistrationPeriod.ONE_YEAR]: 'Expires 12 months from approval date',
  [RegistrationPeriod.TWO_YEARS]: 'Expires 24 months from approval date',
  [RegistrationPeriod.SEVEN_DAYS]: 'Short-term operating authority',
  [RegistrationPeriod.NINETY_DAYS]: 'Seasonal or project-based operation',
}

register<RegistrationPeriod>(RegistrationPeriod, (v) => {
  if (!v) return '\u2014'
  return RegistrationPeriodLabels[v]
})
